import FieldCrmAccount from "./system/crm/account/crm-account"
import FieldCrmContact from "./system/crm/contact/crm-contact"
import FieldCrmContacts from "./system/crm/contacts/crm-contacts"
import FieldBaseline from "./system/gantt/baseline/baseline"
import FieldProto from "./proto/field-proto";
import {FieldType} from "./field-type";
import {EntityType} from "../gd/const/item";
import getTaskColumnField from "../model2/task/column-id-to-field"

// const debug = "FieldConverter21"
const debug = false


// Eto mega stranni class
// ya dumau on dlya soringa uzaetsya v table / list new field -> old sorting


export default class FieldConverter21 {

    public isField2 : boolean = true
    public field2 : FieldProto
    public listItemSortFunctions    : func
    public sortHintMessage    : string

    static getFieldByType(fieldType:FieldType, entityType:EntityType|null = null) {

        debug && console.log(debug, 'getFieldByType() fieldType=', fieldType, "entityType=", entityType)

        const field2Config :any  = {}
        let field : any

        switch (fieldType) {

            case gd.const.fields.type.CRM_CONTACTS:

                field2Config.fieldId = 'crmContactIds'

                return new FieldConverter21(

                    new FieldCrmContacts(field2Config),
                    (sort) => ({
                        functions   : [(i:any) => i.item[field2Config.fieldId] ? i.item[field2Config.fieldId].length : 0],
                        directions  : [sort]
                    }),
                    'Sort by # contacts'
                )

            case gd.const.fields.type.CRM_CONTACT:

                field2Config.fieldId = 'crmContactId'
                field = new FieldCrmContact(field2Config)

                return new FieldConverter21(
                    field,
                    (sort) => ({
                        functions   : [(i:any) => field.sortValue(i.item[field2Config.fieldId])],
                        directions  : [sort]
                    }),
                    'Sort by contact'
                )

            case gd.const.fields.type.CRM_ACCOUNT:
                field2Config.fieldId = 'crmAccountId'
                field = new FieldCrmAccount(field2Config)

                return new FieldConverter21(
                    field,
                    (sort) => ({
                        functions   : [(i:any) => field.sortValue(i.item[field2Config.fieldId])],
                        directions  : [sort]
                    }),
                    'Sort by account'
                )

            case gd.const.fields.type.BASELINE:
                field2Config.fieldId = 'baselineResult'
                field = new FieldBaseline(field2Config)

                return new FieldConverter21(
                    field,
                    (sort) => ({
                        functions   : [(i:any) => field.sortValue(i.item[field2Config.fieldId])],
                        directions  : [sort]
                    }),
                    'Sort by baseline'
                )

            default: {
                const field = getTaskColumnField(fieldType)
                if (!field) {
                    console.error("#998dkd - unknown type")
                    return null
                }

                return new FieldConverter21(
                    field,
                    (sort) => ({
                        functions   : [(i:any) => field.sortValue(i.item[field.fieldId])],
                        directions  : [sort]
                    }),
                    'Sort by {}'.f(field.typeLabel)
                )
            }
        }
    }

    constructor(field2:FieldProto, listItemSortFunctions:func, sortHintMessage:string) {

        debug && console.log(debug, "constructor() field3=", field2)

        // this.isField2 = true

        this.field2 = field2

        this.listItemSortFunctions = listItemSortFunctions
        this.sortHintMessage = sortHintMessage
    }

    getDefaultAggregateFunction() {
        return this.field2.getDefaultAggregateFunction()
    }

    getAggregateOptions() {
        return this.field2.getAggregateOptions()
    }

    getAggregateValue(model:any) {
        return this.field2.getAggregateValue(model)
    }

    getAggregateClass() {
        return this.field2.getAggregateClass()
    }

    get AggregateComponent() {
        return this.field2.AggregateComponent
    }

    isFormulaCompatible() {
        return this.field2.isFormulaCompatible()
    }

    getCsvValue(item:any) {
        return this.field2.getCsvValue(item)
    }
}